import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./lib/auth";
import { App } from "./app";
import { ToastProvider } from "./components/notifications/toast-provider";
import { captureAndReadPartnerSource } from "./lib/partner-storage";
import "./globals.css";

// WO-4: capture ?partner= attribution BEFORE React renders. The root route
// redirects signed-out visitors to the marketing site via
// window.location.replace, so an effect-based capture would race that
// navigation. A synchronous localStorage write here is deterministic and
// idempotent (first capture wins). The slug is read back at auth submit in
// components/auth/sign-in.tsx and forwarded as user_metadata.partner_source.
try {
  captureAndReadPartnerSource(window.location.search, localStorage);
} catch { /* localStorage unavailable in some private modes; ignore */ }

// React.StrictMode removed — it causes double-invoke of effects which
// creates a race condition with Supabase's onAuthStateChange listener,
// resulting in the sign-in form appearing to submit but making no network
// request on the second and subsequent attempts.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </AuthProvider>
  </HelmetProvider>,
);
